import axiosInstance from './axios';

// Example API functions
export const api = {
    // Auth related endpoints
    auth: {
        signIn: (credentials) => axiosInstance.post('userauth', credentials),
        signOut: (accessToken) => axiosInstance.get('logout', accessToken),
        getMe: () => axiosInstance.get('me'),
        getUsers: (params = {}) => {
            const queryString = new URLSearchParams(params).toString();
            return axiosInstance.get(`/get-users?${queryString}`);
        },
        createUser: (data) => axiosInstance.post('create-user', data),
        changePassword: (data) => axiosInstance.post('change-password', data),
        resetPassword: (data) => axiosInstance.post('reset-password', data)
        // register: (userData) => axiosInstance.post("/auth/register", userData),
    },

    // Users related endpoints
    users: {
        getUsers: (params = {}) => {
            const page = params.page || 1;
            const limit = params.limit || 10;
            const queryString = new URLSearchParams(params).toString();
            return axiosInstance.get(`/users?page=${page}&limit=${limit}&${queryString}`);
        },
        createUser: (data) => axiosInstance.post('users', data),
        toggleBlockUser: (userId) => axiosInstance.post(`user-block/${userId}`)
    },
    constitutions: {
        getConstitutions: (params = {}) => {
            const queryString = new URLSearchParams(params).toString();
            const page = params.page || 1;
            const limit = params.limit || 10;
            return axiosInstance.get(`/constitutions?page=${page}&limit=${limit}&${queryString}`);
        },
        createConstitution: (data) => axiosInstance.post('constitutions', data),
        updateConstitution: (data) => axiosInstance.patch(`constitutions`, data),
        deleteConstitution: (id) => axiosInstance.delete(`constitutions/${id}`),
        getConstitution: (id) => axiosInstance.get(`constitutions/${id}`)
    },
    upload: {
        getUploads: (params = {}) => {
            const queryString = new URLSearchParams(params).toString();
            const materialTypeId = params.materialTypeId || null;
            const page = params.page || 1;
            const limit = params.limit || 100;
            return axiosInstance.get(`/materials?page=${page}&limit=${limit}&material_type_id=${materialTypeId}&${queryString}`);
        },
        createUpload: (data) => axiosInstance.post('materials', data),
        updateUpload: (data) => axiosInstance.patch(`materials`, data),
        deleteUpload: (id) => axiosInstance.delete(`materials/${id}`)
    },
    materials: {
        getMaterial: (id) => axiosInstance.get(`materials/${id}`)
    },

    materialTypes: {
        getMaterialTypes: (params = {}) => {
            const queryString = new URLSearchParams(params).toString();
            return axiosInstance.get(`material-types?${queryString}`);
        },
        createMaterialType: (data) => axiosInstance.post('material-types', data),
        updateMaterialType: (data) => axiosInstance.patch(`material-types`, data),
        deleteMaterialType: (id) => axiosInstance.delete(`material-types/${id}`)
    },
    thumbnails: {
        getThumbnail: (uri) => {
            return axiosInstance.get(`fsthumbnails/${uri}`);
        }
    },
    mediaTypes: {
        getMediaTypes: (params = {}) => {
            const page = params.page || 1;
            const limit = params.limit || 10;
            const queryString = new URLSearchParams(params).toString();
            return axiosInstance.get(`media-types?page=${page}&limit=${limit}&${queryString}`);
        },
        createMediaType: (data) => axiosInstance.post('media-types', data),
        updateMediaType: (data) => axiosInstance.patch(`media-types`, data),
        deleteMediaType: (id) => axiosInstance.delete(`media-types/${id}`)
    },
    timeline: {
        getTimeline: (params = {}) => {
            const page = params.page || 1;
            const limit = params.limit || 10;
            const queryString = new URLSearchParams(params).toString();
            return axiosInstance.get(`timeline?page=${page}&limit=${limit}&${queryString}`);
        },
        createTimeline: (data) => axiosInstance.post('timeline', data),
        updateTimeline: (data) => axiosInstance.patch(`timeline`, data),
        deleteTimeline: (id) => axiosInstance.delete(`timeline/${id}`)
    },
    manuals: {
        getManuals: (params = {}) => {
            const queryString = new URLSearchParams(params).toString();
            return axiosInstance.get(`manuals?${queryString}`);
        },
        getManual: (uri) => axiosInstance.get(`fsmanuals/${uri}`)
    },
    roles: {
        getRoles: (params = {}) => {
            const queryString = new URLSearchParams(params).toString();
            return axiosInstance.get(`roles?${queryString}`);
        },
        createRole: (data) => axiosInstance.post('roles', data),
        updateRole: (data) => axiosInstance.patch(`roles`, data),
        deleteRole: (id) => axiosInstance.delete(`roles/${id}`)
    }
};

export default api;
